import React from 'react';
import appstore from '../images/appstore.svg'
import googleplay from '../images/googleplay.svg'
import phones from '../images/phones.svg'

function Advert(props) {
    return (
        <div>
                <div className="bg-[url('images/features.svg')] rounded-[16px] text-white container mx-auto flex flex-col lg:flex-row items-center justify-between h-full">
                    <div className="w-full self-end mb-4 lg:mb-0 h-full justify-center lg:justify-start lg:pt-10 mt-2">
                        <img
                            src={phones}
                            alt="Yebokenny App Screenshot"
                            className="lg:w-full self-end object-contain lg:object-cover"
                        />
                    </div>
                    <div className="w-full text-center lg:text-left">
                    <h1 className="text-[20px] lg:text-4xl font-bold mb-2">
                        Boost Visibility, Get Recommendation, Attract Customers
                    </h1>
                    <p className="text-[18px] lg:text-lg mb-8 px-2">
                        Join the Yebokenny Community and Grow Your Business
                    </p>
                    {/* <div className="flex flex-col lg:flex-row justify-center items-center lg:justify-start space-y-2 lg:space-y-0 lg:space-x-4 mb-10 lg:mb-0">
                        <a
                        href="#"
                        className="text-white rounded-md flex items-center space-x-2 hover:bg-gray-800 transition"
                        >
                        <img
                            src={appstore}
                            alt="App Store"
                            className=""
                        />
                        </a>
                        <a
                        href="#"
                        className="text-white rounded-md flex items-center space-x-2 hover:bg-gray-800 transition"
                        >
                        <img
                            src={googleplay}
                            alt="Google Play"
                            className=""
                        />
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default Advert;